import { APIConfiguration } from '@savgroup-front-common/configuration';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.workflow}owners/${COMMON_QUERY_PARAMS.OWNER_ID}/files/${COMMON_QUERY_PARAMS.FILE_ID}`;

export interface GetOwnerFileQueryArgs {
  ownerId: string;
  fileId: string;
}

export const getOwnerFileRequest = (
  payload: GetOwnerFileQueryArgs,
): ApiRequestDescriptor => ({
  url: ENDPOINT.replace(COMMON_QUERY_PARAMS.OWNER_ID, payload.ownerId).replace(
    COMMON_QUERY_PARAMS.FILE_ID,
    payload.fileId,
  ),
  config: { method: SUPPORTED_METHODS.GET },
});

const getOwnerFileQuery = async (
  payload: GetOwnerFileQueryArgs,
): Promise<
  BackResponse<Record<string, unknown>> | BackResponseFailure
> => {
  try {
    return await executeQuery<BackResponse<Record<string, unknown>>>(
      getOwnerFileRequest(payload),
    );
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
};

export default getOwnerFileQuery;
